const loadedAuthBackgrounds = new Set<string>();

export const hasLoadedAuthBackground = (backgroundKey: string) =>
  loadedAuthBackgrounds.has(backgroundKey);

export const markAuthBackgroundLoaded = (backgroundKey: string) => {
  loadedAuthBackgrounds.add(backgroundKey);
};
